import { Card } from 'antd';
import { IBusinessID } from '../../../types/bussiness';
import Map, { Marker } from '../../Map';
import { IMAGES } from '../../../const/images';

const BusinessLocation = ({ business }: { business: IBusinessID }) => {
    const businessLocation = { lat: business.latitude, lng: business.longitude };

    return (
        <Card title="Location">
            <div style={{ height: 300 }}>
                <Map pos1={businessLocation}>
                    <Marker {...businessLocation}>
                        <img
                            style={{ margin: '-30px 0 0 -15px' }}
                            alt="marker"
                            src={IMAGES.icons.store_location}
                        />
                    </Marker>
                </Map>
            </div>
        </Card>
    );
};

export default BusinessLocation;
